(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vertaro-price-sort')) {
 customElements.define('vertaro-price-sort', class extends HTMLElement {
  connectedCallback() {
   this.querySelectorAll('[data-price-sort]').forEach(link => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', link.dataset.priceSort);
    url.searchParams.delete('page');
    url.searchParams.delete('filter.v.price.gte');
    url.searchParams.delete('filter.v.price.lte');
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    link.href = url.toString();
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vertaro-gift-price')) {
    customElements.define('vertaro-gift-price', class extends HTMLElement {
      connectedCallback() {
        const currency = this.dataset.currency;
        const price = Number(this.dataset.price) / 100;
        if (!currency || !Number.isFinite(price)) return;
        // Shopify Liquid represents even zero-decimal currency prices in hundredths.
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency, currencyDisplay: 'code'
        });
        const digits = formatter.resolvedOptions().maximumFractionDigits;
        const factor = 10 ** digits;
        const discount = Math.round(price * 0.3 * factor) / factor;
        const amount = this.dataset.secondPair === 'true'
          ? Math.round(Number(this.dataset.regularPrice) / 100 * 0.36 * factor) / factor
          : Math.max(0, price - discount);
        const regularPrice = Number(this.dataset.regularPrice) / 100;
        const savingsOutput = this.querySelector('[data-offer-savings]');
        if (savingsOutput && regularPrice > 0) {
          const percent = Math.round((regularPrice - amount) / regularPrice * 1000) / 10;
          savingsOutput.textContent = this.dataset.savingsTemplate.replace('__PERCENT__', String(percent));
        }
        const output = this.querySelector('[data-offer-amount]');
        if (!output) return;
        const template = this.dataset.moneyTemplate;
        const match = template && template.match(/\d[\d.,\s\u00a0\u202f]*\d/);
        if (!match) return;
        const numberPattern = match[0];
        const decimalMatch = numberPattern.match(/([.,])89$/);
        const decimal = decimalMatch ? decimalMatch[1] : '';
        const integerPattern = decimalMatch ? numberPattern.slice(0, -3) : numberPattern;
        const group = integerPattern.match(/[^\d]/)?.[0] || '';
        const parts = amount.toFixed(decimal ? 2 : 0).split('.');
        const integer = group ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group) : parts[0];
        const formatted = integer + (decimal ? decimal + parts[1] : '');
        output.textContent = template.replace(numberPattern, formatted);
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vertaro-drawer-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vertaro-drawer-localization')) {
    customElements.define('vertaro-drawer-localization', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        const form = this.querySelector('form');
        if (!form) return;
        const updateReturnTo = () => {
          const url = new URL(window.location.href);
          url.searchParams.delete('section_id');
          url.searchParams.delete('sections');
          const input = form.querySelector('input[name="return_to"]');
          if (input) input.value = url.pathname + url.search + url.hash;
        };
        updateReturnTo();
        form.addEventListener('submit', updateReturnTo);
        this.addEventListener('change', (event) => {
          if (event.target instanceof HTMLSelectElement) form.requestSubmit();
        });
        this.setAttribute('data-enhanced', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vertaro-height-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vertaro-height-filter')) {
    customElements.define('vertaro-height-filter', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKey);
        document.addEventListener('click', this.handleOutside);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKey);
        document.removeEventListener('click', this.handleOutside);
      }
      handleClick = (event) => {
        const link = event.target.closest('[data-height-link]');
        if (!link) return;
        const destination = new URL(link.getAttribute('href'), location.origin);
        const current = new URL(location.href);
        for (const [key, value] of current.searchParams) {
          if (key !== 'page' && key !== 'section_id' && key !== 'sections') destination.searchParams.append(key, value);
        }
        link.href = destination.href;
      };
      handleKey = (event) => {
        if (event.key !== 'Escape') return;
        const details = this.querySelector('details');
        details.open = false;
        details.querySelector('summary').focus();
      };
      handleOutside = (event) => {
        if (!this.classList.contains('vh-height--drawer') && !this.contains(event.target)) this.querySelector('details').open = false;
      };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vertaro-review-summary"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-vertaro-review-filter]';
  function nativeRow(rating) {
    return Array.from(document.querySelectorAll('#judgeme_product_reviews .jm-histogram-row'))
      .find(row => row.getAttribute('aria-label')?.endsWith('with ' + rating + ' star rating'));
  }
  function sync() {
    document.querySelectorAll(selector).forEach(summary => {
      summary.querySelectorAll('[data-rating]').forEach(button => {
        const row = nativeRow(button.dataset.rating);
        button.disabled = !row || row.getAttribute('aria-disabled') === 'true';
      });
      const reset = summary.querySelector('[data-rating-reset]');
      reset.hidden = !summary.dataset.activeRating;
      const row = nativeRow(summary.dataset.activeRating);
      reset.disabled = !row || row.getAttribute('aria-disabled') === 'true';
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-rating], [data-rating-reset]');
    const summary = button?.closest(selector);
    if (!summary || button.disabled) return;
    const previous = summary.dataset.activeRating || '';
    const rating = button.hasAttribute('data-rating-reset') ? previous : button.dataset.rating;
    const row = nativeRow(rating);
    if (!row || row.getAttribute('aria-disabled') === 'true') return;
    row.click();
    const selected = previous === rating ? '' : rating;
    summary.dataset.activeRating = selected;
    summary.querySelectorAll('[data-rating]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.rating === selected)));
    summary.querySelector('[data-rating-status]').textContent = selected
      ? summary.querySelector('[data-rating="' + selected + '"]').dataset.filterLabel
      : summary.dataset.allLabel;
    sync();
  });
  function init() {
    sync();
    const widget = document.querySelector('#judgeme_product_reviews');
    if (widget && !widget.dataset.vertaroFilterObserved) {
      widget.dataset.vertaroFilterObserved = 'true';
      new MutationObserver(sync).observe(widget, {childList: true, subtree: true, attributes: true, attributeFilter: ['aria-disabled']});
    }
  }
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vertaro-shipping-note"] && !Shopify.designMode) return;
  try {
    class VertaroShippingProgress extends HTMLElement {
    static get observedAttributes() { return ['data-total', 'data-currency', 'data-always-free']; }
    connectedCallback() {
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this, {childList: true, subtree: true});
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    attributeChangedCallback() { if (this.isConnected) this.update(); }
    update() {
      const free = this.querySelector('[data-free]');
      const paid = this.querySelector('[data-paid]');
      const remaining = this.querySelector('[data-remaining-text]');
      if (!free || !paid || !remaining) return;
      const currency = this.dataset.currency;
      const total = Number(this.dataset.total);
      const alwaysFree = this.dataset.alwaysFree === 'true';
      const liveCurrency = window.Shopify?.currency;
      const rate = currency === 'USD' ? 1 : this.dataset.baseCurrency === 'USD' && liveCurrency?.active === currency ? Number(liveCurrency.rate) : NaN;
      const valid = Number.isFinite(rate) && rate > 0 && Number.isFinite(total) && total >= 0;
      const threshold = valid ? Math.ceil(20000 * rate - 0.000001) : NaN;
      const qualifies = alwaysFree || (valid && total >= threshold);
      const meter = this.querySelector('.vertaro-shipping-meter');
      const fill = this.querySelector('[data-shipping-fill]');
      if (meter && fill) {
        const progress = alwaysFree ? 100 : valid ? Math.min(100, total / threshold * 100) : 0;
        meter.hidden = !alwaysFree && !valid;
        meter.setAttribute('aria-valuenow', String(Math.round(progress)));
        fill.style.width = progress + '%';
      }
      free.hidden = !qualifies;
      paid.hidden = qualifies;
      remaining.hidden = qualifies || !valid;
      if (!qualifies && valid) {
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency}).format((threshold - total) / 100);
        const message = this.dataset.remaining.replace('__AMOUNT__', amount);
        if (remaining.textContent !== message) remaining.textContent = message;
      }
    }
  }
  if (!customElements.get('vertaro-shipping-progress')) customElements.define('vertaro-shipping-progress', VertaroShippingProgress);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vertaro-welcome-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vertaro-welcome-offer')) {
    customElements.define('vertaro-welcome-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const launcher = this.querySelector('[data-launcher]');
        const dialog = this.querySelector('dialog');
        const openButton = this.querySelector('[data-open]');
        if (!launcher || !dialog || !openButton) return;
        const read = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
        const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
        const remove = (key) => { try { sessionStorage.removeItem(key); } catch {} };
        let completed = read('vertaro-welcome-completed') === '1';
        let submitting = false;
        let autoShown = read('vertaro-welcome-auto-shown') === '1';
        const dismissed = read('vertaro-welcome-dismissed') === '1';
        launcher.hidden = completed || dismissed || !autoShown;
        const form = this.querySelector('#VertaroWelcomeForm');
        const openOffer = () => {
          clearTimeout(this.offerTimer);
          autoShown = true;
          write('vertaro-welcome-auto-shown', '1');
          if (!dialog.open) dialog.showModal();
        };
        openButton.addEventListener('click', openOffer);
        this.querySelector('[data-close]').addEventListener('click', () => dialog.close());
        this.querySelector('[data-dismiss]').addEventListener('click', () => { launcher.hidden = true; write('vertaro-welcome-dismissed', '1'); });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          launcher.hidden = completed || submitting;
          if (!launcher.hidden) openButton.focus();
        });
        form?.addEventListener('submit', () => {
          submitting = true;
          clearTimeout(this.offerTimer);
          launcher.hidden = true;
          write('vertaro-welcome-submitted', '1');
          // A showModal() dialog makes CAPTCHA's external challenge frame inert.
          // Close only after valid native submission; leave the form and email intact
          // so Shopify can verify the visitor and finish the original submission.
          if (dialog.open) dialog.close();
        }, { capture: true });
        const result = this.querySelector('[data-form-success], [data-form-error]');
        const returnedHere = window.location.hash === '#VertaroWelcomeForm' || read('vertaro-welcome-submitted') === '1';
        if (result && returnedHere) {
          remove('vertaro-welcome-submitted');
          completed = result.hasAttribute('data-form-success');
          if (completed) write('vertaro-welcome-completed', '1');
          launcher.hidden = true;
          openOffer();
          if (result.hasAttribute('data-form-error')) this.querySelector('#VertaroWelcomeEmail')?.focus();
        } else if (!completed && !dismissed && !autoShown && this.dataset.designMode !== 'true') {
          const started = Number(read('vertaro-welcome-started')) || Date.now();
          write('vertaro-welcome-started', String(started));
          const tryOpen = () => {
            if (!this.isConnected || completed || submitting || autoShown) return;
            if (document.hidden || document.querySelector('dialog[open], .shopify-pc__banner__dialog, header-drawer > details[open], .vertaro-region-menu[open]') || this.ownerDocument.activeElement?.matches('input, textarea, select')) {
              this.offerTimer = setTimeout(tryOpen, 1000);
              return;
            }
            openOffer();
          };
          this.offerTimer = setTimeout(tryOpen, Math.max(0, 15000 - (Date.now() - started)));
        } else if (this.dataset.designMode === 'true' && !completed) {
          launcher.hidden = false;
        }
      }
      disconnectedCallback() {
        clearTimeout(this.offerTimer);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
